import { useState } from 'react';

import { AuthContext } from '@/contexts';

export const AuthProvider = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState(true);

  const onAuthorized = () => setIsAuthorized(true);
  const onUnauthorized = () => setIsAuthorized(false);

  return (
    <AuthContext.Provider
      value={{ isAuthorized, onAuthorized, onUnauthorized }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
